import { categoriasPet } from '../../helpers/funcoesAuxiliares';
import { verificarExcecaoPetPorLocalidade } from '../validadoresComunsPorPlano/excecoes';
import {
    retornaLabelDoValorParentesco, validatorMaior79Anos, validatorAte64Anos, validatorMaiorIgual65Anos, validatorParentescoEmDuplicidade
} from './funcoesAuxiliaresZT';

export class CorrenteCadastroZT {
    constructor(dependentes, parentesco, categorias, valoresForm, isValid) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.isValid = isValid;
        this.maximoDependentesPet = 1;
    }

    possui14Dependentes() {
        const qtdDependentesTotais = this.dependentes.length;

        if (qtdDependentesTotais === 14) {
            this.arrayMsgsErro.push('Este plano permite apenas 14 dependentes.');
        }

        return this;
    }

    parentescoComAdicionalAte64() {
        if (validatorAte64Anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes de até 64 anos, o adicional permitido é o ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    parentescoComAdicionalMaiorIgual65() {
        if (validatorMaiorIgual65Anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes acima de 65 anos, o adicional permitido é o ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    parentescoComAdicionalMaior79() {
        if (validatorMaior79Anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes acima de 79 anos, o adicional permitido é o ZELO MAIOR 79 ANOS.');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(`${retornaLabelDoValorParentesco(this.parentesco)}`);
        }

        return this;
    }

    excecaoPetPorLocalidade() {
        if (verificarExcecaoPetPorLocalidade(this.valoresForm.Categoria.trim(), this.valoresForm.Parentesco.trim())) {
            this.arrayMsgsErro = [];
        }

        return this;
    }

    permitirDependentePetSomenteComAdicionalPet() {
        if (this.valoresForm.Parentesco.trim() === 'PET' && !categoriasPet.includes(this.valoresForm.Categoria.trim())) {
            this.arrayMsgsErro.push('Somente é permitido dependente PET que tenha como adicional referente ao PET');
        }

        return this;
    }

    limitarQuantidadePet() {
        const numeroDependentesPet = this.dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === 'PET').length;

        if (numeroDependentesPet >= this.maximoDependentesPet && this.valoresForm.Parentesco && this.valoresForm.Parentesco.trim() === 'PET') {
            this.arrayMsgsErro.push(`Só é permitido um dependente do tipo ${this.valoresForm.Parentesco}.`);
        }

        return this;
    }
}
